module.exports = __webpack_public_path__ + "static/img/12.86c6358.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/12.png
// module id = hEkB
// module chunks = 0